import { make } from 'vuex-pathify'
import Dashboard from '@/api/dashboard'
import moment from 'moment'

const state = {
  tasks: [],
  projects: [],
  //
  monthsLabel: [],
  monthsData: [],

  isFetch: false
}

const mutations = {
  ...make.mutations(state)

}

const actions = {
  async index({ commit, state }) {
    if (state.isFetch) {
      return false
    }

    try {
      const response = await Dashboard.index()

      commit('SET_IS_FETCH', true)
      commit('SET_TASKS', response.data.tasks)
      commit('SET_PROJECTS', response.data.projects)

      const months = []
      const data = []
      for (let i = 5; i >= 0; i--) {
        const month = moment().subtract(i, 'months').format('MM/YYYY')
        months.push(month)
        const monthPoint = response.data.month_points.find(item => item.month === month)
        const points = monthPoint ? monthPoint.points : 0
        data.push(points)
      }

      commit('SET_MONTHS_LABEL', months)

      commit('SET_MONTHS_DATA', data)

      return response
    } catch (e) {
      return false
    }
  }
}

const getters = {
  ...make.getters(state)
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
